export default {
  login: {
    title: "Login",
    username: "Username",
    password: "Password",
    submit: "Sign In",
    reset: "Reset"
  },
  client: {
    title: "Client List",
    sales: "Sales",
    export: "Export Excel",
    filter_placeholder: "Filter by Sales"
  },
  survey: {
    title: "Panda Scanner - Support Survey",
    intro: `Thank you for your interest in Panda Scanner. To ensure that you receive timely and accurate support,
please select your country or region so that we can assign the appropriate sales representative to assist you.`,
    intro2: `Your information will be used solely for support and service coordination purposes.`,
    name: "Name",
    email: "Email",
    whatsapp: "WhatsApp Number",
    occupation: "Occupation",
    country: "Country or Region",
    selectCountry: "Select country or region",

    submit: "Submit",

    placeholder: {
      name: "Your name",
      email: "Your email",
      whatsapp: "e.g. +1 234 567 8900"
    },

    validation: {
      name: "Please enter your name.",
      required: "This field is required.",
      emailRequired: "Please enter your email address.",
      emailInvalid: "Please enter a valid email address.",
      country: "Please select your country or region."
    },

    sales: {
      title: "Your Regional Sales Contact",
      noSalesTitle: "Add Sales Contact",
      desc: "Our local sales representative will assist you with product inquiries and cooperation.",
      noDesc: "No sales contact is assigned to this region yet. Please ask on-site staff to assist in adding sales contact information.",
      whatsapp: "WhatsApp",
      email: "Email",
      add: "Add",
      edit: "Edit Sales Contact"
    },

    dialog: {
      add: "Add Sales Contact",
      edit: "Edit Sales Contact",
      cancel: "Cancel",
      save: "Save"
    },

    tip: {
      succeeded: "Submit succeeded!",
      failed: "Submit failed!"
    },

    occupations: {
      DENTIST: 'Dentist',
      DISTRIBUTOR: 'Distributor',
      DENTAL_LAB: 'Dental Lab',
      KOL: 'KOL',
      OTHER: 'Other',
      UNKNOWN: 'unknown'
    }
  }
}
